import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {mapLayersControl, TrailerIntervention} from 'shared';
import {InterventionsRequest} from '../interventions-toolbar/interventions-toolbar.component';
import {mapStreetLayer} from 'shared';
import {GeoJSON, Map, Polygon, tileLayer} from 'leaflet';
import {ReplaySubject} from 'rxjs';
import {first} from 'rxjs/operators';
import * as L from 'leaflet';
import {TimePieChartEntry} from '../../reports/charts/time-pie-chart/time-pie-chart.component';

@Component({
  selector: 'app-intervention-report',
  templateUrl: './intervention-report.component.html',
  styleUrls: ['./intervention-report.component.scss']
})
export class InterventionReportComponent implements OnInit {

  @Input()
  visible: boolean;

  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Input()
  intervention: TrailerIntervention;

  @Input()
  request: InterventionsRequest;


  private map: Map;
  private _mapSubject = new ReplaySubject<Map>(1);
  mapReady$ = this._mapSubject.asObservable();
  selectedTab = 0;

  layers = [
    {
      name: 'Hybride',
      layer: tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=ar-MA&gl=MA', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),
    },
    {
      name: 'Satellite',
      layer: tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}&hl=ar-MA&gl=MA', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),
    },
  ];

  mapOptions = {
    layers: this.layers.map(l => l.layer),
    zoom: 7,
    minZoom: 0,
    maxZoom: 21,
    maxNativeZoom: 21,
    preferCanvas: false,
    center: [33.626756199999996, -7.4964748]
  };

  private workingMultiPolygon: GeoJSON;
  private fieldPolygon: Polygon<any>;
  timeReport: TimePieChartEntry[];
  title: string;

  constructor() {
    this.close = this.close.bind(this);
  }

  ngOnInit(): void {
  }

  onMapReady(map: Map) {
    this.map = map;
    this._mapSubject.next(map);
  }

  closed(e: any) {
    this.visibleChange.emit(false);
  }

  onShowing(e: any) {

    this.buildTimeReport();

    this.mapReady$.pipe(first()).subscribe(() => {

      // Clean the map
      this.cleanMap();

      // Add field to map
      if (this.intervention.field) {
        this.addFieldToMap();

      }

      // Add working multipolygon
      this.addWorkingMultipolygonToMap();
    });
  }

  onShown(e: any) {
    this.title = `Rapport d'Intervention: ${this.intervention.tractor_name} - ${this.intervention.trailer_name}`;
  }

  addFieldToMap() {
    const f = this.intervention.field;
    this.fieldPolygon = f.createLayer({
      weight: 2,
      opacity: 0.4,
      fillOpacity: 0.3,
      color: f.color,
    });

    this.map.addLayer(this.fieldPolygon);

    this.map.fitBounds(this.fieldPolygon.getBounds(), {
      padding: [15, 15],
      maxZoom: 22,
    });

    /*// Tag icon
    const icon = L.divIcon({
      className: 'map-field-area',
      html: f.polygonAreaToHaUnit(),
    });
    // Create layer
    const m = new L.Marker(this.fieldPolygon.getBounds().getCenter(), {icon});

    m.addTo(this.map);*/
  }

  addWorkingMultipolygonToMap() {
    this.workingMultiPolygon = this.intervention.toGeoJSON();
    if (!this.workingMultiPolygon) {
      return;
    }
    this.workingMultiPolygon.setStyle({
      fillColor: '#4ef34a',
      fill: true,
      weight: 1,
      interactive: true,
      fillOpacity: 0.6,
      color: '#04b800',
      stroke: true,
    });
    this.workingMultiPolygon.addTo(this.map);
  }

  removeFieldFromMap() {
    if (this.fieldPolygon) {
      this.fieldPolygon.remove();
    }
  }

  removeWorkingMultipolygonFromMap() {
    if (this.workingMultiPolygon) {
      this.workingMultiPolygon.remove();
    }
  }

  cleanMap() {
    this.removeFieldFromMap();
    this.removeWorkingMultipolygonFromMap();
  }

  private buildTimeReport() {
    this.timeReport = [
      {name: 'Travail', duration: this.intervention.drive_working_duration},
      {name: 'Arrêt', duration: this.intervention.stop_working_duration},
      {name: 'Trajet', duration: this.intervention.total_road_duration},
    ];
  }

  selectTab(e: any) {
    this.selectedTab = e.itemIndex;
  }

  close() {
    this.visible = false;
  }
}
